export default __webpack_public_path__ + "static/media/54.ab1facec.jpeg";